import { get, patch, post, put } from '../libs/api/apiConnector';
import apiRoutes from '../helpers/apiRoutes';
import replaceParameters from '../helpers/parameterHelper';

export const getUserDetails = async () => {
  try {
    const url = apiRoutes.USER.GET_USER_PROFILE_DETAILS;
    const config = {
      detachAccessToken: true,
      detachRoleToken: true,
    };
    const { data } = await get(url, { config });
    return data;
  } catch (error) {
    console.error(`error ${error}`);
    return error;
  }
};

export const updateUserDetails = async (body, id) => {
  try {
    const url = replaceParameters(apiRoutes.USER.UPDATE_USER_PROFILE_DETAILS, { id });
    const config = {
      detachAccessToken: true,
      detachRoleToken: true,
    };
    const { data } = await patch(url, body, { config });
    return data;
  } catch (error) {
    console.error(`error ${error}`);
    return error.response.data;
  }
};


// Profile -> users
export const getUserList = async (params) => {
  try {
    const { data } = await get(apiRoutes.USER.GET_USER_LIST, { params });
    return data;
  } catch (error) {
    console.error(`get-user-list-error ${error}`);
    return error.response.data;
  }
}

export const getSingleUserDetails = async (userId) => {
  try {
    const url = replaceParameters(apiRoutes.USER.GET_SINGLE_USER_DETAILS, { userId })
    const { data } = await get(url);
    return data;
  } catch (error) {
    console.error(`get-single-user-details-error ${error}`);
    return error.response.data;
  }
}

export const updateSingleUserDetails = async (userId, payload) => {
  try {
    const url = replaceParameters(apiRoutes.USER.GET_SINGLE_USER_DETAILS, { userId })
    const { data } = await put(url, payload);
    return data;
  } catch (error) {
    console.error(`update-single-user-details-error ${error}`);
    return error.response.data;
  }
}

export const updateSingleUserPassword = async (userId, payload) => {
  try {
    const url = replaceParameters(apiRoutes.USER.UPDATE_SINGLE_USER_PASSWORD, { userId })
    const { data } = await put(url, payload);
    return data;
  } catch (error) {
    console.error(`update-single-user-password-error ${error}`);
    return error.response.data;
  }
}

export const createNewUser = async (payload) => {
  try {
    const { data } = await post(apiRoutes.USER.GET_USER_LIST, payload);
    return data;
  } catch (error) {
    console.error(`create-new-user-error ${error}`);
    return error.response.data;
  }
}